export default "__VITE_ASSET__$uWEt01G__"